import {createBrowserHistory} from 'history'

/**
 * Creates a history object that uses the HTML5 history API
 */
export default createBrowserHistory()
